import React from 'react';
import MA from '../assets/availability-1.png';
import CB from '../assets/customer-booking.png';
import SR from '../assets/services-repairs-5.png';
import IN from '../assets/invoices-3.png';
import MB from '../assets/manage-bookings-5.png';
import CS from '../assets/customer-summary.png'
import { Link } from 'react-router-dom';
import phoneFrame  from '../assets/phone-frame.png'

interface Reel {
  src: string
  label: string
}

const reels: Reel[] = [
  { src: CB, label: 'Customers book in 3 clicks'         },
  { src: CS, label: 'Simple for customers'         },
  { src: SR, label: 'Add services & repairs'         },
  { src: MA, label: 'Set your availability'      },
  { src: IN, label: 'Manage your invoices'     },
  { src: MB, label: 'Send customer notifications'      },
]

const Screenshots: React.FC = () => (
  <section className="container section animate-fadeInUp">
    <h2>See it in action</h2>
    <div className="screenshots-slider">
      {reels.map(({ src, label }, idx) => (
        <div
          key={idx}
          className="screenshots-phone-mockup"
          style={{ background: `no-repeat center/contain url(${phoneFrame})` }}
        >
          {/* ① caption bubble */}
          <div className="screenshot-label">
            {label}
          </div>

          {/* ② actual screenshot */}
          <img
            src={src}
            alt={label}
            className="screenshots-phone-screenshot"
          />
        </div>
      ))}
    </div>
    <div className="section-cta">
      <Link to="/get-started" className="cta">Get started for free</Link>
    </div>
  </section>
)

export default Screenshots
